import React from 'react';

import { CATEGORICAL_CHART_TOKENS } from './categorical-chart-tokens';
import BaseTable from './components/base-table';

/**
 * __Categorical chart tokens table__
 *
 * A categorical chart tokens table lists all the categorical chart tokens and their descriptions.
 *
 *
 */
const CategoricalChartTokensTable = (): React.JSX.Element => (
	<BaseTable tableData={CATEGORICAL_CHART_TOKENS} categoryName="Token" />
);
export default CategoricalChartTokensTable;
